import React, { HTMLProps } from 'react';

const FormTextArea = ({
  label,
  id,
  invalid,
  ...props
}: {
  label?: string;
  id: string;
  placeholder: string;
  invalid?: boolean;
} & HTMLProps<HTMLTextAreaElement>) => {
  return (
    <div>
      <label htmlFor={id} className="sr-only">
        {label}
      </label>
      <textarea
        id={id}
        className={`shadow-sm block w-full sm:text-sm rounded-md py-4 mt-4 mb-1 ${
          invalid
            ? 'border-red-500 focus:ring-red-500 focus:border-red-500'
            : 'border-gray-300 focus:ring-primary focus:border-primary'
        }`}
        {...props}
      />
    </div>
  );
};

export default FormTextArea;
